import { hugeiconShapes, currentIconStyle } from "../icons/hugeicons"
import type { HugeiconKey } from "../icons/hugeicons"

// needs to be synced with
//  - app/models/place.rb
//  - app/frontend/api/places/placeCategories.ts
//  - app/frontend/ui/components/mapbox/markers.ts
export const placeCategoryIconMapping: Record<string, { icon: HugeiconKey | null; color: string }> = {
  Default: {
    icon: null,
    color: "#7ace75",
  },
  "Food & Drinks": {
    icon: "restaurant",
    color: "#f44336",
  },
  "Culture & Recreation": {
    icon: "mask-theater",
    color: "#4caf50",
  },
  "Local Farm / Agricultural": {
    icon: "barns",
    color: "#4caf50",
  },
  Services: {
    icon: "building",
    color: "#2196f3",
  },
  "Shopping & Retail": {
    icon: "store",
    color: "#9c27b0",
  },
  "Public Resources": {
    icon: "bank",
    color: "#f69300",
  },
  "Travel & Lodging": {
    icon: "bed",
    color: "#e91e63",
  },
}

// A colored pin with the category's Hugeicon in white, in the CivicLift-wide icon style.
// Drawn on a 35x90 canvas with the pin in the top half (the point at the vertical center),
// the same shape as the Mapbox marker images it replaced, so existing layouts still line up.
const pinSvg = (color: string, icon: HugeiconKey | null): string => {
  const shapes = icon ? hugeiconShapes(icon, { color: "#ffffff" }) : null
  const glyph = shapes
    ? `<g fill="none" transform="translate(8 7) scale(0.79)">${shapes}</g>`
    : `<circle cx="17.5" cy="16.5" r="4.5" fill="#ffffff"/>`
  return (
    `<svg xmlns="http://www.w3.org/2000/svg" width="35" height="90" viewBox="0 0 35 90">` +
    `<path d="M17.5 44.5C17.5 44.5 2.75 28.5 2.75 16.5a14.75 14.75 0 0 1 29.5 0c0 12-14.75 28-14.75 28z" ` +
    `fill="${color}" stroke="#ffffff" stroke-width="1.5"/>${glyph}</svg>`
  )
}

const pinUrls = new Map<string, string>()

export const iconUrlForCategory = (categoryName?: string): string => {
  const mapping = Object.prototype.hasOwnProperty.call(placeCategoryIconMapping, categoryName || "")
    ? placeCategoryIconMapping[categoryName as string]
    : placeCategoryIconMapping.Default
  const cacheKey = `${currentIconStyle()}|${mapping.icon}|${mapping.color}`
  let url = pinUrls.get(cacheKey)
  if (!url) {
    url = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(pinSvg(mapping.color, mapping.icon))}`
    pinUrls.set(cacheKey, url)
  }
  return url
}
